import { render, staticRenderFns } from "./taxi-services-in-goa.vue?vue&type=template&id=56924806&scoped=true"
import script from "./taxi-services-in-goa.vue?vue&type=script&lang=js"
export * from "./taxi-services-in-goa.vue?vue&type=script&lang=js"
import style0 from "./taxi-services-in-goa.vue?vue&type=style&index=0&id=56924806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56924806",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
